import React from 'react';
import GlpmReportParamsBlock from './GlpmReportParamsBlock';
import ReportGenerateButton from './ReportGenerateButton';

const CLEAR_BTN_STYLE = {
  background: '#6c757d',
  color: 'white',
  border: 'none',
  padding: '5px 10px',
  borderRadius: '4px',
  cursor: 'pointer',
  fontSize: '12px',
};

/**
 * Секция I: заголовок, «Параметры отчёта», таблица полей, опционально кнопка «Сформировать».
 */
const GlpmReportParamsSection = ({
  idPrefix,
  handbooks,
  glpmPickerFormData,
  openPicker,
  month,
  onMonthChange,
  maxMonth,
  showMonth = true,
  showQuarter = false,
  quarter,
  onQuarterChange,
  showYear = false,
  year,
  onYearChange,
  // false — у отчёта нет параметров (субъект, период): блок выбора не показывается
  showParams = true,
  onClearParams,
  showGenerate = true,
  showGenerateButton = true,
  canGenerate = false,
  canDownload = false,
  generating = false,
  onGenerate,
  onDownload,
  reportPreview,
  children,
}) => (
  <>
    <div className="template-header" style={{
      cursor: 'default',
      padding: '10px',
      backgroundColor: '#f5f5f5',
      borderBottom: '1px solid #ddd',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    }}
    >
      <h3>I. Формирование отчёта</h3>
    </div>
    <div className="template-content">
      <div className="group-section">
        {showParams && (
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: '10px',
          }}
        >
          <h4>Параметры отчёта</h4>
          <button type="button" onClick={onClearParams} style={CLEAR_BTN_STYLE}>
            Очистить
          </button>
        </div>
        )}
        {showParams && (
        <div>
          <GlpmReportParamsBlock
            idPrefix={idPrefix}
            handbooks={handbooks}
            glpmPickerFormData={glpmPickerFormData}
            openPicker={openPicker}
            month={month}
            onMonthChange={onMonthChange}
            maxMonth={maxMonth}
            showMonth={showMonth}
            showQuarter={showQuarter}
            quarter={quarter}
            onQuarterChange={onQuarterChange}
            showYear={showYear}
            year={year}
            onYearChange={onYearChange}
          />
        </div>
        )}
        {children}
        {showGenerate && (
          <div style={{
            display: 'flex',
            gap: '10px',
            flexWrap: 'wrap',
            marginTop: '18px',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}>
            {showGenerateButton ? (
              <ReportGenerateButton
                disabled={!canGenerate || generating}
                loading={generating}
                onClick={onGenerate}
              />
            ) : <span />}
            {/* Кнопка «Скачать» появляется справа от таблицы только после формирования отчёта */}
            {canDownload && (
              <ReportGenerateButton
                disabled={generating}
                loading={false}
                onClick={onDownload}
                label="Скачать"
              />
            )}
          </div>
        )}
        {reportPreview}
      </div>
    </div>
  </>
);

export default GlpmReportParamsSection;
